import colors from 'shared/library/colors';

export type IllustrationImagePalette = {
  background: string;
  far: string;
  near: string;
  spot: string;
};

// Illustration accents complement the product palette without changing UI colors.
export const illustrationPalette = {
  paper: colors.brand['cream-light'],
  cream: colors.brand.cream,
  creamDark: colors.brand['cream-dark'],
  ink: colors.brand.brown,
  forest: colors.brand['green-dark'],
  green: colors.brand.green,
  sage: colors.brand['green-semilight'],
  sageLight: colors.brand['green-light'],
  sky: '#dce9f0',
  blue: '#7b9faf',
  peach: '#f2d3c0',
  clay: '#bb816b',
  lilac: '#e7dff0',
  violet: '#9d8bb2',
  yellow: '#f1dfa6',
} as const;

export const illustrationImagePalettes = {
  forest: {
    background: illustrationPalette.sage,
    far: '#7ca48c',
    near: illustrationPalette.forest,
    spot: illustrationPalette.paper,
  },
  clay: {
    background: illustrationPalette.peach,
    far: illustrationPalette.clay,
    near: illustrationPalette.forest,
    spot: illustrationPalette.paper,
  },
  olive: {
    background: '#e1e9b9',
    far: '#a4b779',
    near: illustrationPalette.forest,
    spot: illustrationPalette.paper,
  },
  cream: {
    background: illustrationPalette.creamDark,
    far: '#7ca48c',
    near: illustrationPalette.forest,
    spot: illustrationPalette.paper,
  },
} satisfies Record<string, IllustrationImagePalette>;
